export const richTextStyles = ['small', 'big', 'blue', 'green', 'red', 'pink'];
export const emojis = ['♥️', '☺️', '☺', '‼️'];
export const kaomojis = ['ᕙ( ︡’︡益’︠)ง'];

export const noSupport = {
  audio: 'Your browser does not support the audio element.'
};
